import { gql } from '@zenbusiness/application-commons-graphql';

export const DELETE_COUNTER_PARTY_MUTATION = gql`
  mutation deleteBankingCounterparty($input: BankingCounterpartyInput!) {
    deleteBankingCounterparty(input: $input) {
      success
    }
  }
`;

export const UPDATE_COUNTER_PARTY_STATUS_MUTATION = gql`
  mutation updateBankingPartnerCounterparty($input: UpdateBankingCounterpartyInput!) {
    updateBankingPartnerCounterparty(input: $input) {
      id
      name
      bank
      routingNumber
      accountNumber
      accountType
      type
      status
      connectedType
      fullAccountNumber
      wire {
        routingNumber
        address {
          street
          city
          state
          postalCode
          country
        }
      }
    }
  }
`;

export const ADD_PAYEE_MUTATION = gql`
  mutation createBankingPayeeCounterparty($input: CreateBankingPayeeInput!) {
    createBankingPayeeCounterparty(input: $input) {
      id
      name
      nickname
      bank
      routingNumber
      accountNumber
      accountType
      type
      status
      connectedType
      fullAccountNumber
      firstName
      lastName
      isACHSupported
      isWireSupported
      wire {
        routingNumber
        address {
          street
          city
          state
          postalCode
          country
        }
      }
    }
  }
`;

export const EDIT_PAYEE_MUTATION = gql`
  mutation updateBankingPayeeCounterparty($input: UpdateBankingPayeeInput!) {
    updateBankingPayeeCounterparty(input: $input) {
      id
      name
      nickname
      bank
      routingNumber
      accountNumber
      accountType
      type
      status
      connectedType
      fullAccountNumber
      firstName
      lastName
      wire {
        routingNumber
        address {
          street
          city
          state
          postalCode
          country
        }
      }
    }
  }
`;
